var apps = [
  {
    name: 'Assistant',
    icon: 'assistant',
    type: 'app',
    padd: true
  },
  {
    name: 'BuyMeACoffee',
    icon: 'buyme',
    action: 'home/openLink',
    payload: 'https://buymeacoffee.com/blueedgetechno',
    type: 'app'
  },
  {
    name: 'Calender',
    icon: 'calender',
    type: 'app',
    padd: true
  },
  {
    name: 'Chrome',
    icon: 'chrome',
    type: 'app',
    padd: true
  },
  {
    name: 'Classroom',
    icon: 'classroom',
    type: 'app',
    padd: true
  },
  {
    name: 'Contacts',
    icon: 'contacts',
    type: 'app'
  },
  {
    name: 'Discord',
    icon: 'discord',
    type: 'app',
    action: 'home/openLink',
    payload: 'https://discord.gg/NcjaNdwtnR'
  },
  {
    name: 'Docs',
    icon: 'docs',
    type: 'app',
    padd: true
  },
  {
    name: 'Drive',
    icon: 'drive',
    type: 'app',
    padd: true
  },
  {
    name: 'Duo',
    icon: 'duo',
    type: 'app'
  },
  {
    name: 'Earth',
    icon: 'earth',
    type: 'app'
  },
  {
    name: 'Forms',
    icon: 'forms',
    type: 'app',
    padd: true
  },
  {
    name: 'GBoard',
    icon: 'gboard',
    type: 'app',
    padd: true
  },
  {
    name: 'Github',
    icon: 'github',
    type: 'app',
    action: 'home/openLink',
    payload: 'https://github.com/blueedgetechno/androidInReact',
    padd: true
  },
  {
    name: 'Gmail',
    icon: 'gmail',
    type: 'app',
    action: 'home/openLink',
    payload: 'mailto:blueedgetechno@gmail.com',
    padd: true
  },
  {
    name: 'Search',
    icon: 'google',
    type: 'app',
    padd: true
  },
  {
    name: 'Google Fit',
    icon: 'googlefit',
    type: 'app',
    padd: true
  },
  {
    name: 'GPay',
    icon: 'googlepay',
    type: 'app',
    padd: true
  },
  {
    name: 'Keep Notes',
    icon: 'keep',
    type: 'app',
    padd: true
  },
  {
    name: 'Maps',
    icon: 'maps',
    type: 'app',
    padd: true
  },
  {
    name: 'Meet',
    icon: 'meet',
    type: 'app',
    padd: true
  },
  {
    name: 'Messages',
    icon: 'messages',
    type: 'app'
  },
  {
    name: 'News',
    icon: 'news',
    type: 'app'
  },
  {
    name: 'Photos',
    icon: 'photos',
    type: 'app',
    padd: true
  },
  {
    name: 'Books',
    icon: 'playbooks',
    type: 'app',
    padd: true
  },
  {
    name: 'Movies',
    icon: 'playmovies',
    type: 'app',
    padd: true
  },
  {
    name: 'Play Store',
    icon: 'playstore',
    type: 'app',
    padd: true
  },
  {
    name: 'Apps',
    icon: 'ssapps',
    type: 'app'
  },
  {
    name: 'Settings',
    icon: 'settings',
    type: 'app'
  },
  {
    name: 'Sheets',
    icon: 'sheets',
    type: 'app',
    padd: true
  },
  {
    name: 'Slides',
    icon: 'slides',
    type: 'app',
    padd: true
  },
  {
    name: 'Browser',
    icon: 'ssbrowser',
    type: 'app'
  },
  {
    name: 'Calculator',
    icon: 'sscalculator',
    type: 'app'
  },
  {
    name: 'Calender',
    icon: 'sscalender',
    type: 'app'
  },
  {
    name: 'Camera',
    icon: 'sscamera',
    type: 'app'
  },
  {
    name: 'Clock',
    icon: 'ssclock',
    type: 'app'
  },
  {
    name: 'Contacts',
    icon: 'sscontacts',
    type: 'app'
  },
  {
    name: 'Files',
    icon: 'ssfiles',
    type: 'app'
  },
  {
    name: 'Gallery',
    icon: 'ssgallery',
    type: 'app'
  },
  {
    name: 'Health',
    icon: 'sshealth',
    type: 'app'
  },
  {
    name: 'Keyboard',
    icon: 'sskeyboard',
    type: 'app'
  },
  {
    name: 'Mail',
    icon: 'ssmail',
    type: 'app'
  },
  {
    name: 'Members',
    icon: 'ssmember',
    type: 'app'
  },
  {
    name: 'Messages',
    icon: 'ssmessages',
    type: 'app'
  },
  {
    name: 'Music',
    icon: 'ssmusic',
    type: 'app'
  },
  {
    name: 'Notes',
    icon: 'ssnotes',
    type: 'app'
  },
  {
    name: 'Phone',
    icon: 'ssphone',
    type: 'app'
  },
  {
    name: 'Radio',
    icon: 'ssradio',
    type: 'app'
  },
  {
    name: 'Reader',
    icon: 'ssreader',
    type: 'app'
  },
  {
    name: 'Recorder',
    icon: 'ssrecorder',
    type: 'app'
  },
  {
    name: 'Themes',
    icon: 'ssthemes',
    type: 'app'
  },
  {
    name: 'Translate',
    icon: 'sstranslate',
    type: 'app'
  },
  {
    name: 'Unescape',
    icon: 'unescape',
    type: 'app',
    action: 'home/openLink',
    payload: 'https://blueedge.me/unescape'
  },
  {
    name: 'Videos',
    icon: 'ssvideo',
    type: 'app'
  },
  {
    name: 'Translate',
    icon: 'translate',
    type: 'app'
  },
  {
    name: 'Twitter',
    icon: 'twitter',
    type: 'app',
    action: 'home/openLink',
    payload: 'https://twitter.com/blueedgetechno'
  },
  {
    name: 'WhatsApp',
    icon: 'whatsapp',
    type: 'app'
  },
  {
    name: 'Youtube',
    icon: 'youtube',
    type: 'app',
    padd: true
  }
]

export default apps
